<template>
    <div id="modal_component" class="modal-component" v-if="modal">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="hideModal()"></div>
                        <div class="modal-inner">
                            <form @submit.prevent="validate">
                                <p class="p1" v-if="security == 'GOOGLE_AUTHENTICATOR'">Put here code from google
                                    authenticator<br> and confirm your transaction:</p>
                                <p class="p1" v-if="security == 'EMAIL'">Check your email address, put here code from
                                    message<br> and confirm your transaction.</p>
                                <div class="modal-form-item">
                                    <input type="text"
                                           name="code"
                                           v-model="code"
                                           v-validate
                                           data-vv-rules="required">
                                    <p class="field-error--description" v-show="errors.has('code') && showErrors">{{
                                        errors.first('code') }}</p>
                                    <p class="field-error--description" v-show="!validCode">Invalid code, please try
                                        again.</p>
                                </div>
                                <div class="form-actions">
                                    <div class="button--cancel"
                                         @click="progress ? '' : hideModal()">Cancel
                                    </div>
                                    <button class="button--action button--confirm"
                                            :class="{ 'button--progress': progress }"
                                            :type="progress ? 'button' : 'submit'">Confirm
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['api', 'payout', 'popup'],
        data() {
            return {
                code: '',
                validCode: true,
                showErrors: false,
                progress: false
            }
        },
        computed: {
            security() {
                return this.$store.getters.settings.confirmations.payouts ? this.$store.getters.settings.confirmations.payouts.value : ''
            },
            modal() {
                return this.$store.getters.modals.payout.visible
            }
        },
        methods: {
            hideModal() {
                this.code = ''
                this.validCode = true
                this.showErrors = false
                this.$store.commit('modals', {
                    modal: 'payout',
                    data: {
                        visible: false,
                        params: {}
                    }
                })
            },
            validate() {
                this.showErrors = false
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit()
                    } else {
                        this.showErrors = true
                    }
                })
            },
            submit() {
                this.progress = true;
                this.payout.create(this.$store.getters.modals.payout.params);
                this.payout.setToken(this.code);
                this.payout.submit().then(() => {
                    this.hideModal();
                    this.progress = false;
                }, () => {
                    this.hideModal();
                    this.progress = false;
                })
            }
        },
        mounted() {
            this.popup.show('In order to improve the process of payments and withdrawals, we established a cooperation with a new service provider. Currently work is underway on the implementation of the system - until then, the use of the bank transfer will only be possible in GBP currency. We encourage our users to use alternative methods. We apologize for the inconvenience.', 'I understand', false);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/Payout.vue